import React from 'react';
import { Card, CardBody, Col, Dropdown, DropdownItem, DropdownMenu } from 'reactstrap';
import { Action, AnotherAction, BasicColorDropdown, SeparatedLink, SomethingElseHere } from '../../../Constant';
import HeaderCard from '../../Common/HeaderCard';
import { BasicColorData } from '../../../Data/Ui-kit/Data';
import CommonDropDown from './Common/CommonDropDown';
import { Btn } from '../../../AbstractElements';
import { ButtonGroup } from 'react-bootstrap';

const BasicColor = () => {
  return (
    <Col sn='12' xl='12'>
      <Card>
        <HeaderCard title={BasicColorDropdown} />
        <CardBody className='dropdown-basic'>
          <ButtonGroup>
            <Dropdown>
              <Btn color='primary dropbtn btn-square d-flex gap-2'>
                {Action}
                <span>
                  <i className='icofont icofont-arrow-down'></i>
                </span>
              </Btn>
              <DropdownMenu className='dropdown-content'>
                <DropdownItem href='#'>{Action}</DropdownItem>
                <DropdownItem href='#'>{AnotherAction}</DropdownItem>
                <DropdownItem href='#'>{SomethingElseHere}</DropdownItem>
                <DropdownItem divider />
                <DropdownItem href='#'>{SeparatedLink}</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </ButtonGroup>
          {BasicColorData.map((items) => (
            <CommonDropDown key={items.id} item={items} />
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default BasicColor;
